import clsx from 'clsx';
import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import HighlightedText from '../highlighted-text/HighlightedText';
import { EMPTY_DROPDOWN_OPTION } from '../../constants';

import '../common-menu/CommonMenu.scss';

const MultiselectMenu = ({ options = [], onSelect, searchStr, onAddNewOption, isTop, selectedValues }) => {
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (selectedValue) => {
      if (selectedValue.value) {
        onSelect(selectedValue);
      }
    },
    [onSelect],
  );

  const formattedOptions = useMemo(() => (options.length ? options : [EMPTY_DROPDOWN_OPTION]), [options]);

  return (
    <div
      className={clsx(
        'common-menu',
        'common-menu--no-submenu',
        'multiselect_dropdown',
        isTop && 'multiselect_dropdown--top',
      )}>
      {formattedOptions.map(({ value, label, disabled }, index) => (
        <div
          key={value}
          onClick={() => (value === 'NEW_VALUE' ? onAddNewOption() : handleSelect(formattedOptions[index]))}
          role='presentation'>
          <div
            className={clsx(
              'common-dropdown_item',
              !value && 'multiselect_dropdown_item--empty',
              disabled && 'multiselect_dropdown_item--disabled',
              selectedValues?.some((item) => item.value === value) && 'multiselect_dropdown_item--selected',
            )}>
            {value ? <HighlightedText value={label} searchTerm={value === 'NEW_VALUE' ? '' : searchStr} /> : t('empty')}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(MultiselectMenu);
